import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import OverviewShell from '../overview_shell/OverviewShell';

const style = require('./FieldTechsOverviewPage.less');

const FieldTechsOverviewPage: FC<any> = ({ history, childRoutes }): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/supplier/fieldTechs/overview/${key}`),
		[history]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = [
		{
			key: 'all',
			name: 'Overview',
		},
		{
			key: 'wrenchModeLogs',
			name: 'Work Logs',
		},
	];

	return (
		<>
			<Route
				path="/supplier/fieldTechs/overview"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: '/supplier/fieldTechs/overview/all',
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Field Technicians"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="fieldTechsPage"
			/>
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(FieldTechsOverviewPage)
);
